export const parseURLParams = (url) => {
  var queryStart = url.indexOf("?") + 1,
    queryEnd = url.indexOf("#") + 1 || url.length + 1,
    query = url.slice(queryStart, queryEnd - 1),
    pairs = query.replace(/\+/g, " ").split("&"),
    parms = {},
    i,
    n,
    v,
    nv;

  if (query === url || query === "") return;

  for (i = 0; i < pairs.length; i++) {
    nv = pairs[i].split("=", 2);
    n = decodeURIComponent(nv[0]);
    v = decodeURIComponent(nv[1]);

    if (!parms.hasOwnProperty(n)) parms[n] = [];
    parms[n].push(nv.length === 2 ? v : null);
  }
  return parms;
};

export const timeSince = (date) => {
  var seconds = Math.floor((new Date() - date) / 1000);
  // console.log(date, 'date')
  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years ago";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months ago";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days ago";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours ago";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes ago";
  }
  // console.log("seconds is ", seconds);
  // return false;
  return seconds.toString().indexOf("-") != -1
    ? "0 second ago"
    : Math.floor(seconds) + " seconds ago";
};

export const getDeviceType = () => {
  try {
    const ua = navigator.userAgent;
    console.log(ua);
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return "tablet";
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return "mobile";
    }
    if (/Mobile|iP(hone|od)/.test(ua)) {
      return;
    }
  } catch (er) {
    return "desktop";
  }
  return "desktop";
};

export const appShareTextString = (text) => {
  // text = text ? text.split("'").join("") : "";
  text = text ? text.split("‘").join("'") : "";
  text = text ? text.split("’").join("'") : "";
  text = text ? text.split("‟").join('"') : "";
  text = text ? text.split("“").join('"') : "";
  text = text ? text.split("❝").join('"') : "";
  text = text ? text.split("❞").join('"') : "";
  text = text ? text.split("”").join('"') : "";
  text = text ? text.split("„").join('"') : "";
  return text;
};

export const detectMob = () => {
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
    // true for mobile device
   return 'mobile';
  }else{
    // false for not mobile device
    return 'desktop';
  }
};
